import { Tag } from 'antd';
import React, { ReactElement } from 'react';

interface SourceStateTransitionChipProps {
  chip?: string;
  label?: string;
}

export default function SourceStateTransitionChip({ chip, label }: SourceStateTransitionChipProps): ReactElement {
  switch (chip) {
    case 'ACTIVE':
      return <Tag style={{ backgroundColor: '#EF9A9A', border: 'none' }}>{label}</Tag>;
    case 'BLOCKING':
      return <Tag style={{ backgroundColor: '#AA2800', color: '#fff', border: 'none' }}>{label}</Tag>;
    case 'DRAFT_SCHEMA':
      return <Tag style={{ backgroundColor: '#879BA6', border: 'none' }}>{label}</Tag>;
    case 'HOLD':
      return <Tag style={{ backgroundColor: '#81c784', border: 'none' }}>{label}</Tag>;
    case 'IN_PROGRESS':
      return <Tag style={{ backgroundColor: '#795e83', color: '#fff', border: 'none' }}>{label}</Tag>;
    case 'ISSUE':
      return <Tag style={{ backgroundColor: '#AA2800', color: '#fff', border: 'none' }}>{label}</Tag>;
    case 'MAINTENANCE':
      return <Tag style={{ backgroundColor: '#AA2800', color: '#fff', border: 'none' }}>{label}</Tag>;
    case 'QA':
      return <Tag style={{ backgroundColor: '#795e83', color: '#fff', border: 'none' }}>{label}</Tag>;
    case 'QUEUED':
      return <Tag style={{ backgroundColor: '#66C0B7', border: 'none' }}>{label}</Tag>;
    case 'READY':
      return <Tag style={{ backgroundColor: '#795e83', color: '#fff', border: 'none' }}>{label}</Tag>;
    default:
      return <Tag>{label}</Tag>;
  }
}
